var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 128H213.334l-128 256 426.667 512 426.667-512zM410.453 341.333l64-128h75.093l64 128zm58.88 85.334V711.68L232.106 426.667zm85.334 0h237.227L554.667 711.68zm267.093-85.334H708.693l-64-128H757.76zm-555.52-128h113.067l-64 128H202.24z"
  })));
};
export default SvgDiamond;